export const SET_INITIALISED = 'app/SET_INITIALISED';

export const SET_AWAITING_CALCULATION = 'app/SET_AWAITING_CALCULATION';

export const SET_DATA = 'app/SET_DATA';

export const SET_ERROR = 'app/SET_ERROR';

export const SET_STEP = 'app/SET_STEP';

export const SET_FINANCE_OPTION = 'app/SET_FINANCE_OPTION';

export const SET_FORM_VALUES = 'app/SET_FORM_VALUES';

export const SET_MAKES = 'app/SET_MAKES';

export const SET_DEALERS = 'app/SET_DEALERS';

export const SET_SUBSTEP = 'app/SET_SUBSTEP';

export const SET_LOADED_CONFIGURATION = 'app/SET_LOADED_CONFIGURATION';

export const SET_CALCULATIONS = 'app/SET_CALCULATIONS';

export const SET_FINANCE_PROVIDER_URL = 'app/SET_FINANCE_PROVIDER_URL';
